import React from "react"
import styled from "styled-components"
import { SUCCESS, DANGER } from "const"

type VariantType = typeof SUCCESS | typeof DANGER

const FeedbackSpan = styled.span<{
    variant: VariantType
    show: boolean
    transform: string
}>`
    font-weight: 500;
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    font-family: ${(props) => props.theme.openSans};
    transform: ${(props) => (props.transform || "translateY(-4px)")};
    color: ${(props) => {
        switch (props.variant) {
            case SUCCESS:
                return props.theme.feedbackSuccess
            case DANGER:
            default:
                return props.theme.feedbackDanger
        }
    }};
    opacity: ${(props) => (props.show ? 1 : 0)};
    transition: 0.1s ease;
`

export interface FeedbackProps extends React.HTMLAttributes<HTMLSpanElement> {
    variant?: VariantType
    children?: string
    transform?: string
}

export const Feedback = ({
    variant = DANGER,
    children,
    transform = null,
    ...other
}: FeedbackProps) => (
    <FeedbackSpan
        className="feedback"
        variant={variant}
        show={children && children.length > 0}
        transform={transform}
        {...other}
    >
        {children}
    </FeedbackSpan>
)
